import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useParams, useHistory } from 'react-router-dom'
import { useProductsContext } from './../context/products-context'

// import { single_product_url as url } from './../utils/constants'
import { formatPrice } from '../utils/helpers'
import {
  Loading,
  Error,
  Stars,
  ProductImages,
  PageHero,
  AddToCart,
} from './../components'

const SingleProductPage = () => {
  const { id } = useParams()
  const history = useHistory()
  const {
    singleProduct,
    singleProductLoading,
    singleProductError,
    fetchSingleProduct,
  } = useProductsContext()

  useEffect(() => {
    fetchSingleProduct(`${id}`)
  }, [id])

  useEffect(() => {
    if (singleProductError) {
      setTimeout(() => {
        history.push('/')
      }, 3000)
    }
  }, [singleProductError, history])

  if (singleProductLoading) {
    return <Loading />
  }
  if (singleProductError) {
    return <Error />
  }

  const {
    name,
    price,
    description,
    quantity,
    stars,
    reviews,
    _id: sku,
    company,
    images,
  } = singleProduct

  return (
    <Wrapper>
      <PageHero title={name} product />
      <section className='section section-center page'>
        <Link to='/products' className='btn'>
          back to products
        </Link>

        <section className='product-center'>
          <ProductImages images={images} />
          <section className='content'>
            <h2>{name}</h2>
            <Stars stars={stars} reviews={reviews} />
            <h5 className='price'>{formatPrice(price)}</h5>
            <p className='desc'>{description}</p>

            <p className='info'>
              <span>Available : </span>
              {quantity > 0 ? 'In stock' : 'out of stock'}
            </p>
            <p className='info'>
              <span>SKU : </span>
              {sku}
            </p>
            <p className='info'>
              <span>Brand : </span>
              {company}
            </p>
            <hr />
            {quantity > 0 && <AddToCart product={singleProduct} />}
          </section>
        </section>
      </section>
    </Wrapper>
  )
}

const Wrapper = styled.main`
  .product-center {
    display: grid;
    gap: 4rem;
    margin-top: 2rem;
  }
  .price {
    color: var(--clr-primary-5);
  }
  .desc {
    line-height: 2;
    max-width: 45em;
  }
  .info {
    text-transform: capitalize;
    width: 300px;
    display: grid;
    grid-template-columns: 125px 1fr;
    span {
      font-weight: 700;
    }
  }
  @media (min-width: 992px) {
    .product-center {
      grid-template-columns: 1fr 1fr;
      align-items: center;
    }
    .price {
      font-size: 1.25rem;
    }
  }
`

export default SingleProductPage
